<template>
  <Header />
  <SearchBar origin="reservation" />
  <OffersSlider :type="1" v-if="hasOffers" />
  <Footer />
</template>

<script>
import { defineComponent } from "vue";

// import LocationMap from "@/components/widgets/LocationMap.vue"; // @ is an alias to /src
import SearchBar from "@/components/widgets/SearchBar.vue"; // @ is an alias to /src
import OffersSlider from "@/components/widgets/OffersSlider.vue"; // @ is an alias to /src
import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import Header from "@/components/widgets/Header.vue"; // @ is an alias to /src
import store from "@/store";
export default defineComponent({
  name: "Reservation",
  components: {
    SearchBar,
    OffersSlider,
    Footer,
    Header,
  },
  data() {
    return {
      env: process.env,
      hasOffers: false,
    };
  },
  mounted() {
    this.hasOffers =
      store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE") == "J" &&
      process.env.VUE_APP_OFFERS == "true"
        ? true
        : false;
    console.log(this.hasOffers);
  },
});
</script>
